import { ComponentChildren, Ref, h } from "preact";

import classname from "../../../../foundation/utils/classname";

import styles from "./RightPanelSectionHeader.module.css";

type Props = {
    class?: string;
    baseRef?: Ref<HTMLDivElement>;
    title: ComponentChildren;
    middleContent?: ComponentChildren;
    rightContent?: ComponentChildren;
};

function RightPanelSectionHeader({
    class: cssClass,
    baseRef,
    title,
    middleContent,
    rightContent
}: Props) {
    return (
        <div class={classname(styles.rightPanelSectionHeader, cssClass, "body-1")} ref={baseRef}>
            <div class={styles.leftContainer}>
                <span class={classname(styles.title, "caption-2 semibold ellipsis")}>
                    {title}
                </span>
                {middleContent}
            </div>
            {!!rightContent && (
                <div class={styles.rightContentContainer}>
                    {rightContent}
                </div>
            )}
        </div>
    );
}

export default RightPanelSectionHeader;
export { Props as RightPanelSectionHeaderProps };
